<style lang="scss" scoped>
// .equ {
//   position: absolute;
//   width: 415px;
//   height: 200px;
//   right: 0px;
//   top: 220px;
//   background-image: url("../../../../../assets/pagesImg/air-equ.png");
// }
.equ {
  width: 415px;
  height: 200px;
  cursor: pointer;
  .kongtiao {
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    .data {
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .number {
        font-size: 48px;
        font-family: "dina";
      }
    }
    .data:nth-child(1) {
      .number {
        color: #2d82ff;
      }
    }
    .data:nth-child(3) {
      .number {
        color: #f1802f;
      }
    }
  }
}
</style>

<template>
  <div class="equ" @click="to('/aircondition')">
    <custom-plane
      title="空调系统"
      :iconImg="require('@/assets/compImg/EquipmentIcon/kongtiao.png')"
    >
      <div class="kongtiao">
        <div v-for="(item, index) in kongtiaoList" :key="index" class="data">
          <p>{{ item.title }}</p>
          <p class="number">{{ item.num }}</p>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    kongtiaoList: Array,
  },
  methods: {
    to(path) {
      this.$router.push({ path });
    },
  },
};
</script>
